import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';

export const TableContainer = styled.div`
  background: ${({ theme }) => theme.background.primary};
  border: 1px solid ${({ theme }) => theme.border.color.medium};
  border-radius: ${({ theme }) => theme.border.radius.md};
  overflow-x: auto;
  overflow-y: hidden;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const Th = styled.th`
  text-align: left;
  padding: ${({ theme }) => theme.spacing(2, 3)};
  font-size: ${({ theme }) => theme.font.size.xs};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  color: ${({ theme }) => theme.font.color.tertiary};
  background: ${({ theme }) => theme.background.secondary};
  border-bottom: 1px solid ${({ theme }) => theme.border.color.medium};
  white-space: nowrap;
`;

export const Td = styled.td`
  padding: ${({ theme }) => theme.spacing(2, 3)};
  font-size: ${({ theme }) => theme.font.size.sm};
  color: ${({ theme }) => theme.font.color.primary};
  border-bottom: 1px solid ${({ theme }) => theme.border.color.light};
  white-space: nowrap;
`;

interface TableRowProps {
  clickable?: boolean;
}

export const TableRow = styled('tr', {
  shouldForwardProp: prop => isPropValid(prop) && prop !== 'clickable'
})<TableRowProps>`
  cursor: ${({ clickable = true }) => (clickable ? 'pointer' : 'default')};
  transition: ${({ theme }) => theme.animation.transition.standard};

  &:hover {
    background: ${({ theme }) => theme.background.tertiary};
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: none;
    box-shadow: inset ${({ theme }) => theme.focusShadow(theme.accent.tertiary)};
  }

  &:last-of-type td {
    border-bottom: none;
  }
`;

export const FilterRow = styled.tr`
  background: ${({ theme }) => theme.background.secondary};

  th {
    padding: ${({ theme }) => theme.spacing(1.5, 3)};
    border-bottom: 1px solid ${({ theme }) => theme.border.color.medium};
  }
`;

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(3)};
  padding: ${({ theme }) => theme.spacing(4, 0)};
  font-size: ${({ theme }) => theme.font.size.sm};
  color: ${({ theme }) => theme.font.color.secondary};
`;
